import { createAssign } from "robodux";
import { all, call, poll, put } from "saga-query";

import { api } from "@app/state/apis/api";

import { pollMatrix } from "../middlewares/pollMatrix";
import { resetGroupData } from "./groups";
import { fusionLogout } from "./login";
import { appNotify } from "./notify";
import { resetUsersData } from "./users";

import type {
  ActionWithPayload,
  ApiCtx,
  CreateAction,
  CreateActionPayload,
} from "saga-query";

const UTILS_REPO = "utils";
export const utilsRepo = createAssign<any>({
  name: UTILS_REPO,
  initialState: {},
});

export const checkSession = api.get(
  "/checkSession",
  { saga: poll(120 * 1000) },
  function* (ctx: ApiCtx, next) {
    ctx.request = ctx.req({
      url: "/s1",
      credentials: "include",
    });
    yield* next();
    const { data, ok } = yield ctx.json;
    if (!ok || !data) {
      yield* call(
        appNotify.run,
        appNotify({
          type: "error",
          message: "Session expired. Please login again.",
          position: "top",
          duration: 5000,
        })
      );
      //todo: logout with a message
      yield* all([
        put(resetGroupData()),
        put(resetUsersData()),
        put(fusionLogout()),
      ]);
    } else {
      // console.log("session ok");
      void 0;
    }
  }
);

export const pollEndpoint = api.get(
  "/pollEndpoint",
  { saga: pollMatrix(5 * 1 * 1000) },
  function* (ctx: ApiCtx, next) {
    ctx.key = "pollEndpoint";
    ctx.request = ctx.req({
      url: "/s1",
      credentials: "include",
    });
    yield* next();
    const { data, ok } = ctx.json;
    if (!ok || !data) {
      yield* call(
        appNotify.run,
        appNotify({
          type: "error",
          message: "Session expired. Please login again.",
          position: "top",
          duration: 5000,
        })
      );
    }
  }
);

export const pollService = (
  theAction: ActionWithPayload<CreateActionPayload<any>>
) => {
  const safeMap: { [key: string]: any } = {};
  return {
    start: () => {
      const {
        payload: { key },
      } = theAction;

      if (safeMap[key] == true) {
        return { type: `nop`, payload: key };
      }
      safeMap[key] = true;
      return theAction;
    },
    stop: () => {
      const {
        type,
        payload: { key },
      } = theAction;
      return { type: `cancel-${type}`, payload: key };
    },
  };
};
